<style lang="scss" scoped>

</style>

<template>
	<Login v-if="routeLogin"></Login>
	<Base v-else></Base>
</template>

<script>

import state from "@/global/state";
import config from "@/global/config";
import utils from "@/global";

import Base from '@/components/Base.vue';
import Login from '@/views/Login.vue';

export default {
    name: 'app',
    components: {
        Base, 
        Login
    },
    provide: {
        state,
        config,
        utils
    },
    data: function () {
        return {
                
        }
    },
    methods: {
        
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        routeLogin: function () {
            if (state.user.loggedIn === false) {
                return true;
            }
            if (this.currentRouteName === 'Login') {
                return true;
            }
            return false;
        }
    },
    mounted: function() {
        state.actions.checkLogIn();
    }
}
</script>